import { Input, Modal, notification } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_ENDPOINTS } from 'assets/api/endpoints';
import { getUserLanguageInCookie } from 'helpers/cookiesHandler';
import { convertMilliseconds } from 'helpers/getRemainingTime';
import { ExclamationCircleFilled, LoadingOutlined } from '@ant-design/icons';
const numberFormatter = (num: number) => {
	const clamped = Math.max(0, num);
	return `${clamped > 9 ? '' : '0'}${clamped}`;
};
const OTP_LENGTH = 6;
export function OTPModal({
	showOtpModal,
	setShowOtpModal,
	vervifyOtp,
	payload,
	loading,
}: {
	showOtpModal: boolean;
	setShowOtpModal: (value: boolean) => void;
	vervifyOtp: (otp: string) => void;
	payload: any;
	loading: boolean;
}) {
	const { t } = useTranslation();
	const [otp, setOtp] = useState(['', '', '', '', '', '']);
	const [minutes, setMinutes] = useState('00');
	const [seconds, setSeconds] = useState('00');
	const [currentCountdown, setCurrentCountdown] = useState(0);
	const workerRef = useRef<Worker | null>(null);
	const hasStartedRef = useRef(false);
	const handleOtpChange = (index: number, value: string) => {
		const newOtp = [...otp];
		newOtp[index] = value;
		if (value !== '' && index < 6) {
			const nextInput = document.getElementById(`otp-input-${index + 1}`) as HTMLInputElement | null;
			if (nextInput) {
				nextInput.focus();
			}
		}
		if (value === '') {
			const nextInput = document.getElementById(`otp-input-${index - 1}`) as HTMLInputElement | null;
			if (nextInput) {
				nextInput.focus();
			}
		}
		setOtp(newOtp);
	};
	const startCountdown = (time: number) => {
		if (workerRef.current) {
			workerRef.current.terminate();
		}
		hasStartedRef.current = true;
		const worker = new Worker('./countDownMillieSeconds.js');
		worker.postMessage({ type: 'init', countdown: time | 0 });
		worker.onmessage = function (e) {
			if (e.data.type === 'countdown') {
				setCurrentCountdown(e.data.countdown);
			} else if (e.data.type === 'completed') {
				setShowOtpModal(false);
			}
		};
		workerRef.current = worker;
	};
	const sendOtp = (resend?: boolean) => {
		axios.post(`${API_ENDPOINTS.openOrderOtp}`, payload).then((res) => {
			if (resend) {
				notification['success']({ message: '', description: t<string>('otpResendMessage') });
			}
			startCountdown(res.data.remainingExpiryTime);
		});
	};
	useEffect(() => {
		if (showOtpModal) {
			setOtp(['', '', '', '', '', '']);
			setMinutes('00');
			setSeconds('00');
			setCurrentCountdown(0);
			hasStartedRef.current = false;
			sendOtp();
		} else {
			if (workerRef.current) {
				workerRef.current.terminate();
				workerRef.current = null;
			}
			hasStartedRef.current = false;
		}
	}, [showOtpModal]);
	useEffect(() => {
		return () => {
			if (workerRef.current) {
				workerRef.current.terminate();
			}
		};
	}, []);
	useEffect(() => {
		const { hours, minutes, seconds } = convertMilliseconds(currentCountdown);
		if (hasStartedRef.current && hours <= 0 && minutes <= 0 && seconds <= 0) {
			setShowOtpModal(false);
			return;
		}
		setMinutes(numberFormatter(Math.max(0, Math.floor(minutes))));
		setSeconds(numberFormatter(Math.max(0, seconds)));
	}, [currentCountdown]);
	return (
		<Modal
			onCancel={() => {
				setShowOtpModal(false);
			}}
			open={showOtpModal}
			footer={null}
			destroyOnClose
			centered
			title={
				<div className='flex align-baseline'>
					<ExclamationCircleFilled className='text-[#0f2147] mx-2' />
					<h4 className='m-0'>{t('confirmWithdrawalRequest')}</h4>
				</div>
			}
		>
			<p>{t<string>('enterYourOtp')}</p>
			<div className='mb-4 flex '>
				<div style={{ direction: 'ltr', marginBlockStart: '5px' }}>
					{otp.map((digit, index) => (
						<Input
							key={index}
							id={`otp-input-${index}`}
							value={digit}
							onChange={(e) => handleOtpChange(index, e.target.value)}
							maxLength={1}
							style={{ width: '2rem', marginRight: '1rem', textAlign: 'center' }}
							onPaste={(e) => {
								const copiedValue = e.clipboardData.getData('text/plain').split('');
								const otpValue =
									copiedValue.length > OTP_LENGTH
										? copiedValue.slice(0, OTP_LENGTH)
										: [...copiedValue, ...Array(OTP_LENGTH - copiedValue.length).fill('')];
								setOtp(otpValue);
							}}
						/>
					))}
				</div>
				<div className='m-auto'>
					{t<string>('expireIn')}:{' '}
					{getUserLanguageInCookie() === 'ar' ? (
						<>
							<span>{seconds}</span> : <span>{minutes}</span>{' '}
						</>
					) : (
						<>
							<span>{minutes}:</span> <span>{seconds}</span>
						</>
					)}
				</div>
			</div>
			<div>
				<p>
					{t<string>('didNotreceiveOtp')}
					<span className='text-[#0184ff] underline cursor-pointer' onClick={() => sendOtp(true)}>
						{t<string>('resend')}
					</span>
				</p>
			</div>
			<button
				disabled={otp.some((value) => value === '') || loading}
				className='form-btn'
				style={{ cursor: 'pointer', margin: '0 auto', maxWidth: '100px', height: '36px', fontWeight: 400 }}
				onClick={() => vervifyOtp(otp.join(''))}
			>
				{loading && <LoadingOutlined />}
				{t<string>('confirm')}
			</button>
		</Modal>
	);
}
